import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Multiselect from 'vue-multiselect'

export default {
	name: 'surface-cargo-mapping',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		Multiselect
	},
	props: [],
	data() {
		return {
			hubzoneLoading: '',
			isLoading: false,
			isLoadingSearch: false,
			IsActive: false,
			statusmodal: false,
			activeHubList: [],
			HubDetails: [],
			hublist: [],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			hubLoading: '',
			modaldata: '',
			createdby: '',
			pageCount: 0,
			pageNo: 0,
			totalRecords: 0,
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubzone: ''

		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdby = userdetail[0].email
		//this.getHubList();
		this.getHubZone();
	},
	methods: {

		getHubZone() {
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.hubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					this.HubZoneListData = result.data.ResponseData;
					for (i = 0; i < this.HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: this.HubZoneListData[i].hubzoneid,
							text: this.HubZoneListData[i].hubzonename
						})
					}
				}, error => {
					console.error(error)
				})
		},

		selectHubZone(hubzoneitem) {
			this.hubzoneitem = hubzoneitem
			this.hubzone = this.hubzoneitem.text
			this.hubzoneid = this.hubzoneitem.id
            this.hub=''
			if (this.hubzoneid != undefined) {
				this.getHubList(this.hubzoneid)
			}
		},

		getHubList() {
			this.hubLoading = 'Loading Hub...'
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					this.HubDetails = []
					this.hublist=[]
					for (var i = 0; i < result.data.ResponseData.length; i++) {
						this.hublist.push({
							"value": result.data.ResponseData[i].HubID,
							"text": result.data.ResponseData[i].HubName + '(' + result.data.ResponseData[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = hubitem.text
		},
		saveHub() {
			var hubname = this.hubitem.text.split('(')
			this.input = ({
				"hubId": this.hubitem.value,
				"createdBy": this.createdby,
				"hubName":hubname[0]
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'activateSurfaceCargoBagForHub',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						//  this.$alertify.success(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "success");
						this.hubitem = {
							value: '',
							text: ''
						}
						this.hub = ''
						this.$validator.reset();
					} else {
						//  this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					console.error(error)
				})
		},
		getActiveHubList() {
			this.activeHubList = []
			var temphubarray = [];
			var tempfinalArray = [];
			this.input = ({})
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getActiveHubsForPortToPortSurfaceBagIn?isActive=' + this.IsActive + '&pageIndex=' + this.pageNo + '&pageSize=10',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						var activeHubList = []
						this.activeHubList = result.data.ResponseData
						//var activeHubList = result.data.ResponseData
						// for (var i = 0; i < this.HubDetails.length; i++) {
						// 	temphubarray[this.HubDetails[i].HubID] = this.HubDetails[i].HubName;
						// }
						// for (var i = 0; i < activeHubList.length; i++) {
						// 	tempfinalArray = [];
						// 	tempfinalArray = activeHubList[i];
						// 	if (activeHubList[i].hubid == "") {
						// 		tempfinalArray["hubname"] = '';
						// 	} else {
						// 		tempfinalArray["hubname"] = temphubarray[activeHubList[i].hubid];
						// 	}
						// 	this.activeHubList.push(tempfinalArray);
						// }
						this.totalRecords = result.data.TotalCount
						if (this.totalRecords < 10) {
							this.pageCount = 1
						} else {
							this.pageCount = Math.ceil(this.totalRecords / 10);
						}
					} else {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					console.error(error)
				})
		},
		openStatusModal(data) {
			this.statusmodal = true
			this.modaldata = data
		},
		//for active/inactive modal
		changeStatus() {
			var newactStatus = this.modaldata.isactive ? false : true
			this.input = {
				"hubId": this.modaldata.hubid,
				"createdBy": this.createdby,
				"isActive": newactStatus
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'deActivateSurfaceCargoBagForHub',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//  this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.getActiveHubList()
					} else {
						//this.$alertify.error(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "error");
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		closeStatusModal() {
			this.statusmodal = false
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.getActiveHubList()
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					this.saveHub();
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SurfaceCargoMapping/SurfaceCargoMapping.js